import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FornecedorDetalharComponent } from './fornecedor-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: FornecedorDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class FornecedorDetalharRoutingModule { }
